// src/utils/mockDataTier5.ts — HV/Switching, ITS Commissioning, Handover & Reports data

// ─────────────────────────────────────────────────────────────────
// HV SWITCHING PROGRAMMES
// ─────────────────────────────────────────────────────────────────
export const MOCK_SWITCHING_PROGRAMMES = [
  {
    id: 'sp1', spNumber: 'ESP-2026-0412',
    jobId: 'j4', jobNumber: 'TP-2026-004',
    networkOperator: 'Energex',
    substationName: 'Annerley Zone Substation',
    substationId: 'ANN-ZSS-001',
    voltageKV: 11,
    equipmentToIsolate: [
      'CB 14B — 11kV Feeder 4 at Annerley ZSS',
      'EF 4 Isolator — Feeder 4',
      'CB 14C — Tie breaker (confirm open before work)',
    ],
    isolationType: 'FULL_ISOLATION',
    minimumApproachDistanceM: 0.9,
    controlRoomOfficerName: 'James Liu',
    controlRoomPhone: '13 62 62',
    authorisationTime: '2026-06-20T06:45:00Z',
    authorisationReference: 'ENX-CR-2026-0412',
    leadTechnicianId: 'e3',
    leadTechnicianName: 'Sam Nguyen',
    leadTechnicianAuthority: 'HV-ENERGEX-2024-0042',
    status: 'SITE_CLEARED',
    issueTime: '2026-06-20T07:00:00Z',
    completionTime: '2026-06-20T14:30:00Z',
    clearanceTime: '2026-06-20T15:00:00Z',
    signons: [
      { employeeId: 'e3', employeeName: 'Sam Nguyen', hvAuthority: 'HV-ENERGEX-2024-0042', signedAt: '2026-06-20T06:55:00Z' },
    ],
    switchingSteps: [
      { stepNumber: 1,  action: 'Confirm CB 14C (tie breaker) open at Annerley ZSS', phase: 'ISOLATION', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:02:00Z', verified: true },
      { stepNumber: 2,  action: 'Open CB 14B at Annerley ZSS (11kV Feeder 4)', phase: 'ISOLATION', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:05:00Z', verified: true },
      { stepNumber: 3,  action: 'Lock EF 4 isolator open — apply padlock (key #A142) and DANGER tag', phase: 'ISOLATION', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:08:00Z', verified: true },
      { stepNumber: 4,  action: 'TEST DEAD — Horstmann 11kV detector on Feeder 4 cable tail at ZSS switchroom (all three phases)', phase: 'TEST_DEAD', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:12:00Z', verified: true },
      { stepNumber: 5,  action: 'Apply MV earths to Feeder 4 cable tail at ANN-ZSS switchroom — all three phases. Confirm secure.', phase: 'EARTH', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:15:00Z', verified: true },
      { stepNumber: 6,  action: 'Apply MV earths to Feeder 4 cable tail at Annerley Sub MCC — all three phases. Confirm secure.', phase: 'EARTH', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:25:00Z', verified: true },
      { stepNumber: 7,  action: 'Report SITE SAFE to Energex CR. Issue clearance to crew. Work may commence.', phase: 'CLEARANCE', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T07:30:00Z', verified: true },
      // Return steps
      { stepNumber: 8,  action: 'Notify Energex CR — work complete. Clearance returned.', phase: 'RETURN_CLEARANCE', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T13:50:00Z', verified: true },
      { stepNumber: 9,  action: 'REMOVE earths from Annerley Sub MCC — all three phases. Confirm removed.', phase: 'REMOVE_EARTH', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T14:00:00Z', verified: true },
      { stepNumber: 10, action: 'REMOVE earths from ANN-ZSS switchroom — all three phases. Confirm removed.', phase: 'REMOVE_EARTH', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T14:10:00Z', verified: true },
      { stepNumber: 11, action: 'Remove DANGER tag. Remove padlock from EF 4 isolator. Re-close isolator.', phase: 'RE_ENERGISE', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T14:20:00Z', verified: true },
      { stepNumber: 12, action: 'Re-close CB 14B at Annerley ZSS. Report to Energex CR. Feeder 4 restored.', phase: 'RE_ENERGISE', completedByName: 'Sam Nguyen', completedAt: '2026-06-20T14:30:00Z', verified: true },
    ],
  },
  {
    id: 'sp2', spNumber: 'ESP-2026-0438',
    jobId: 'j4', jobNumber: 'TP-2026-004',
    networkOperator: 'Energex',
    substationName: 'Annerley Zone Substation',
    substationId: 'ANN-ZSS-001',
    voltageKV: 11,
    equipmentToIsolate: ['CB 14B — 11kV Feeder 4 at Annerley ZSS'],
    isolationType: 'FULL_ISOLATION',
    minimumApproachDistanceM: 0.9,
    controlRoomOfficerName: 'Maria Santos',
    controlRoomPhone: '13 62 62',
    authorisationTime: null,
    authorisationReference: null,
    leadTechnicianId: 'e3',
    leadTechnicianName: 'Sam Nguyen',
    leadTechnicianAuthority: 'HV-ENERGEX-2024-0042',
    status: 'DRAFT',
    issueTime: null,
    completionTime: null,
    clearanceTime: null,
    signons: [],
    switchingSteps: [],
  },
]

export const SP_STATUS: Record<string, { label: string; bg: string; text: string; dot: string }> = {
  DRAFT:            { label: 'Draft',              bg: 'bg-gray-100',   text: 'text-gray-600',  dot: 'bg-gray-400' },
  NETWORK_APPROVED: { label: 'Network approved',   bg: 'bg-blue-100',   text: 'text-blue-700',  dot: 'bg-blue-500' },
  ACTIVE:           { label: 'Active — work zone live', bg: 'bg-green-100', text: 'text-green-700', dot: 'bg-green-500' },
  SITE_CLEARED:     { label: 'Site cleared',        bg: 'bg-purple-100', text: 'text-purple-700',dot: 'bg-purple-500' },
  CLOSED:           { label: 'Closed',              bg: 'bg-gray-200',   text: 'text-gray-500',  dot: 'bg-gray-400' },
}

export const STEP_PHASE_STYLE: Record<string, { bg: string; text: string; label: string }> = {
  ISOLATION:       { bg: 'bg-amber-100', text: 'text-amber-800', label: 'Isolate' },
  TEST_DEAD:       { bg: 'bg-red-100',   text: 'text-red-800',   label: 'Test dead' },
  EARTH:           { bg: 'bg-orange-100',text: 'text-orange-800',label: 'Earth' },
  CLEARANCE:       { bg: 'bg-green-100', text: 'text-green-800', label: 'Clearance' },
  RETURN_CLEARANCE:{ bg: 'bg-blue-100',  text: 'text-blue-800',  label: 'Return clearance' },
  REMOVE_EARTH:    { bg: 'bg-purple-100',text: 'text-purple-800',label: 'Remove earth' },
  RE_ENERGISE:     { bg: 'bg-indigo-100',text: 'text-indigo-800',label: 'Re-energise' },
}

// ─────────────────────────────────────────────────────────────────
// HV CABLE TEST RECORDS
// ─────────────────────────────────────────────────────────────────
export const MOCK_HV_CABLE_RECORDS = [
  {
    id: 'hvcr1', jobId: 'j4', jobNumber: 'TP-2026-004',
    cableType: '11kV 3C 95mm² XLPE Cu — Prysmian Belden',
    routeDescription: 'Annerley ZSS Cable Cellar (Pit 1) → Annerley Sub MCC (Pit 6)',
    lengthMetres: 420,
    voltageClass: '11kV (HV_1)',
    testedByName: 'Sam Nguyen',
    testDate: '2026-06-20',
    insulationResistanceMOhm: 2400,
    continuityTestResult: 'PASS',
    vlfTestResult: 'PASS',
    vlfTestVoltageKV: 17.3,
    vlfTestDurationMin: 60,
    form16Number: 'F16-2026-0042',
    form16IssueDate: '2026-06-21',
    lewName: 'Sam Nguyen',
    lewLicenceNumber: '77456QLD',
    joints: [
      { num: 1, location: 'Pit B — Annerley approach', type: 'STRAIGHT', kit: '3M QS-2000', jointer: 'Sam Nguyen', regNum: 'JTR-2024-0089', date: '2026-06-18', result: 'PASS' },
      { num: 2, location: 'Pit D — mid-route',        type: 'STRAIGHT', kit: '3M QS-2000', jointer: 'Sam Nguyen', regNum: 'JTR-2024-0089', date: '2026-06-19', result: 'PASS' },
    ],
  },
]

// ─────────────────────────────────────────────────────────────────
// ITS COMMISSIONING CHECKLISTS
// ─────────────────────────────────────────────────────────────────
export const ITS_RESULT_META: Record<string, { label: string; bg: string; text: string }> = {
  PASS:        { label: 'Pass',        bg: 'bg-green-100',  text: 'text-green-700' },
  FAIL:        { label: 'Fail',        bg: 'bg-red-100',    text: 'text-red-700' },
  NA:          { label: 'N/A',         bg: 'bg-gray-100',   text: 'text-gray-500' },
  NOT_CHECKED: { label: 'Not checked', bg: 'bg-gray-50',    text: 'text-gray-400' },
}

export type ITSItem = {
  id: string; item: string; critical: boolean
  result: 'PASS'|'FAIL'|'NA'|null; notes: string|null; inspector: string|null; date: string|null
}

export const MOCK_ITS_COMMISSIONING = [
  {
    id: 'itsc1', jobId: 'j1', jobNumber: 'TP-2026-001',
    title: 'SCATS Commissioning — Kessels/Klumpp Rd',
    controllerType: 'SCATS EAMS 1.4 — Advantech ARK-1122',
    scatsNodeId: 'NODE-KSL-042',
    clientRep: 'Sarah Jones (TMR Region 2)',
    targetDate: '2026-08-10',
    status: 'NOT_STARTED',
    phases: [
      {
        phase: 'PRE_COMMISSIONING', label: 'Pre-commissioning checks',
        items: [
          { id: 'c1',  critical: true,  item: 'Controller cabinet installed, secure, and plumb — correct orientation to traffic flow', result: null, notes: null, inspector: null, date: null },
          { id: 'c2',  critical: true,  item: 'Power supply verified — 240V AC at cabinet with correct phase and earth', result: null, notes: null, inspector: null, date: null },
          { id: 'c3',  critical: true,  item: 'All field wiring terminated and labelled per approved drawings', result: null, notes: null, inspector: null, date: null },
          { id: 'c4',  critical: true,  item: 'Insulation resistance test — >100MΩ at 500V DC on all signal circuits', result: null, notes: null, inspector: null, date: null },
          { id: 'c5',  critical: false, item: 'SCATS software version confirmed — EAMS v1.4.2 or later', result: null, notes: null, inspector: null, date: null },
          { id: 'c6',  critical: true,  item: 'Controller configuration file loaded and verified against TMR STREAMS data', result: null, notes: null, inspector: null, date: null },
        ] as ITSItem[]
      },
      {
        phase: 'COMMISSIONING', label: 'Commissioning & functional test',
        items: [
          { id: 'c7',  critical: true,  item: 'All vehicle signal phases cycle in correct order and colour sequence (R-A-G-A-R)', result: null, notes: null, inspector: null, date: null },
          { id: 'c8',  critical: true,  item: 'Pedestrian signal phases respond to PPB demand on all approaches', result: null, notes: null, inspector: null, date: null },
          { id: 'c9',  critical: false, item: 'Pedestrian countdown timers active and display correctly', result: null, notes: null, inspector: null, date: null },
          { id: 'c10', critical: true,  item: 'All vehicle loop detectors reporting to SCATS — confirmed in EAMS diagnostics', result: null, notes: null, inspector: null, date: null },
          { id: 'c11', critical: true,  item: 'SCATS comms link established with TMR STREAMS (Ethernet / fibre) — ping confirmed', result: null, notes: null, inspector: null, date: null },
          { id: 'c12', critical: true,  item: 'Node NODE-KSL-042 confirmed active in TMR STREAMS network map by TMR operator', result: null, notes: null, inspector: null, date: null },
          { id: 'c13', critical: false, item: 'Pedestrian audio and tactile outputs confirmed operational', result: null, notes: null, inspector: null, date: null },
          { id: 'c14', critical: false, item: 'CCTV camera (if fitted) live feed confirmed in STREAMS', result: null, notes: null, inspector: null, date: null },
        ] as ITSItem[]
      },
      {
        phase: 'POST_COMMISSIONING', label: 'Site acceptance & handover',
        items: [
          { id: 'c15', critical: true,  item: 'Form 16 issued and signed by licensed electrical worker', result: null, notes: null, inspector: null, date: null },
          { id: 'c16', critical: true,  item: 'As-built drawings (marked up) submitted to TMR', result: null, notes: null, inspector: null, date: null },
          { id: 'c17', critical: true,  item: 'TMR SCATS Commissioning Checklist v4.2 signed by TMR representative', result: null, notes: null, inspector: null, date: null },
          { id: 'c18', critical: true,  item: 'Handover pack submitted to client (Form 16, as-builts, O&M manual, warranties)', result: null, notes: null, inspector: null, date: null },
          { id: 'c19', critical: false, item: 'Defects liability period commenced — date entered in contract register', result: null, notes: null, inspector: null, date: null },
        ] as ITSItem[]
      },
    ]
  },
  {
    id: 'itsc2', jobId: 'j6', jobNumber: 'TP-2026-006',
    title: 'SCATS ITS Commissioning — Mt Gravatt 4 intersections',
    controllerType: 'SCATS EAMS 1.4 — Advantech ARK-1122',
    scatsNodeId: 'NODE-MGV-011 to NODE-MGV-014',
    clientRep: 'Sarah Jones (TMR Region 2)',
    targetDate: '2026-07-22',
    status: 'NOT_STARTED',
    phases: [
      {
        phase: 'PRE_COMMISSIONING', label: 'Pre-commissioning checks',
        items: [
          { id: 'c20', critical: true,  item: 'Site access confirmed with TMR — all 4 intersection sites', result: null, notes: null, inspector: null, date: null },
          { id: 'c21', critical: true,  item: 'SCATS configuration files for nodes 011–014 received from TMR STREAMS team', result: null, notes: null, inspector: null, date: null },
        ] as ITSItem[]
      },
      {
        phase: 'COMMISSIONING', label: 'Commissioning & functional test',
        items: [
          { id: 'c22', critical: true,  item: 'All 4 nodes commissioned to SCATS network and confirmed in STREAMS', result: null, notes: null, inspector: null, date: null },
          { id: 'c23', critical: true,  item: 'Coordinated phase timing verified between NODE-MGV-011 and NODE-MGV-014', result: null, notes: null, inspector: null, date: null },
        ] as ITSItem[]
      },
      {
        phase: 'POST_COMMISSIONING', label: 'Site acceptance & handover',
        items: [
          { id: 'c24', critical: true,  item: 'Form 16 issued for all 4 sites', result: null, notes: null, inspector: null, date: null },
          { id: 'c25', critical: true,  item: 'TMR sign-off received and handover packs submitted', result: null, notes: null, inspector: null, date: null },
        ] as ITSItem[]
      },
    ]
  },
]

// ─────────────────────────────────────────────────────────────────
// HANDOVER RECORDS
// ─────────────────────────────────────────────────────────────────
export const HANDOVER_DOC_STATUS: Record<string, { label: string; bg: string; text: string }> = {
  COMPLETE:     { label: 'Complete',    bg: 'bg-green-100',  text: 'text-green-700' },
  IN_PROGRESS:  { label: 'In progress', bg: 'bg-blue-100',   text: 'text-blue-700' },
  NOT_STARTED:  { label: 'Not started', bg: 'bg-gray-100',   text: 'text-gray-500' },
  NOT_REQUIRED: { label: 'N/A',         bg: 'bg-gray-50',    text: 'text-gray-400' },
  OVERDUE:      { label: 'Overdue',     bg: 'bg-red-100',    text: 'text-red-700' },
}

export const MOCK_HANDOVER_RECORDS = [
  {
    id: 'ho1', jobId: 'j5', jobNumber: 'TP-2026-005',
    description: 'Ipswich Rd Streetlighting Upgrade Stage 3',
    clientName: 'Brisbane City Council',
    targetHandoverDate: '2026-07-15',
    actualHandoverDate: null,
    dlpMonths: 12,
    dlpStartDate: null,
    dlpEndDate: null,
    status: 'IN_PROGRESS',
    percentageComplete: 78,
    documents: [
      { id: 'hd1', name: 'Form 16 — Electrical Installation Certificate',  required: true,  status: 'COMPLETE',    dueDate: '2026-07-12', notes: 'F16-2026-0038 signed by Tony Rivera (88123QLD)' },
      { id: 'hd2', name: 'As-built drawings — marked-up PDF set',         required: true,  status: 'IN_PROGRESS', dueDate: '2026-07-12', notes: 'Tony preparing as-builts — 80% complete' },
      { id: 'hd3', name: 'O&M manual (LED streetlights)',                  required: true,  status: 'COMPLETE',    dueDate: '2026-07-13', notes: 'Schneider Datalight Pro O&M manual v2.1' },
      { id: 'hd4', name: 'Warranty certificates — LED luminaires',        required: true,  status: 'COMPLETE',    dueDate: '2026-07-13', notes: 'Schneider 5-year luminaire warranty (48 units)' },
      { id: 'hd5', name: 'Photometric compliance report',                  required: false, status: 'NOT_STARTED', dueDate: '2026-07-14', notes: null },
      { id: 'hd6', name: 'Site completion photos (before & after)',        required: true,  status: 'NOT_STARTED', dueDate: '2026-07-14', notes: null },
      { id: 'hd7', name: 'Defects inspection form (self-assessment)',      required: true,  status: 'NOT_STARTED', dueDate: '2026-07-14', notes: null },
      { id: 'hd8', name: 'Handover certificate (generated from system)',   required: true,  status: 'NOT_STARTED', dueDate: '2026-07-15', notes: null },
    ]
  },
  {
    id: 'ho2', jobId: 'j1', jobNumber: 'TP-2026-001',
    description: 'Kessels Rd / Klumpp Rd Intersection Signals Upgrade',
    clientName: 'TMR Region 2',
    targetHandoverDate: '2026-08-15',
    actualHandoverDate: null,
    dlpMonths: 12,
    dlpStartDate: null,
    dlpEndDate: null,
    status: 'NOT_STARTED',
    percentageComplete: 14,
    documents: [
      { id: 'hd9',  name: 'Form 16 — Electrical Installation Certificate',  required: true,  status: 'NOT_STARTED', dueDate: '2026-08-10', notes: null },
      { id: 'hd10', name: 'SCATS Commissioning Certificate (TMR-signed)',    required: true,  status: 'NOT_STARTED', dueDate: '2026-08-10', notes: 'Awaiting SCATS commissioning completion' },
      { id: 'hd11', name: 'As-built drawings — marked-up PDF set',          required: true,  status: 'NOT_STARTED', dueDate: '2026-08-10', notes: null },
      { id: 'hd12', name: 'ITP — all hold points released (evidence)',       required: true,  status: 'IN_PROGRESS', dueDate: '2026-08-10', notes: '1 of 3 hold points remaining — cable IR test pending' },
      { id: 'hd13', name: 'TMR network handback documentation',              required: true,  status: 'NOT_STARTED', dueDate: '2026-08-12', notes: null },
      { id: 'hd14', name: 'O&M manual (traffic signals and SCATS)',          required: true,  status: 'NOT_STARTED', dueDate: '2026-08-12', notes: null },
      { id: 'hd15', name: 'Warranty certificates — signal heads and poles',  required: true,  status: 'NOT_STARTED', dueDate: '2026-08-12', notes: null },
      { id: 'hd16', name: 'Site completion photos',                          required: true,  status: 'NOT_STARTED', dueDate: '2026-08-14', notes: null },
      { id: 'hd17', name: 'Handover certificate (generated from system)',    required: true,  status: 'NOT_STARTED', dueDate: '2026-08-15', notes: null },
    ]
  },
  {
    id: 'ho3', jobId: 'j4', jobNumber: 'TP-2026-004',
    description: 'Energex HV Cable Replacement — Annerley',
    clientName: 'Energex',
    targetHandoverDate: '2026-07-31',
    actualHandoverDate: null,
    dlpMonths: 6,
    dlpStartDate: null,
    dlpEndDate: null,
    status: 'IN_PROGRESS',
    percentageComplete: 60,
    documents: [
      { id: 'hd18', name: 'Form 16 — HV Cable Installation Certificate',     required: true,  status: 'COMPLETE',    dueDate: '2026-07-25', notes: 'F16-2026-0042 signed — Sam Nguyen (77456QLD)' },
      { id: 'hd19', name: 'VLF Test Certificate — 11kV cable 420m',          required: true,  status: 'COMPLETE',    dueDate: '2026-07-25', notes: 'PASS 17.3kV for 60 min — see HV cable test record' },
      { id: 'hd20', name: 'Cable Joint Records (3M QS-2000 x2)',             required: true,  status: 'COMPLETE',    dueDate: '2026-07-25', notes: 'Joints 1 and 2 tested PASS' },
      { id: 'hd21', name: 'Cable route as-built drawings',                   required: true,  status: 'IN_PROGRESS', dueDate: '2026-07-28', notes: null },
      { id: 'hd22', name: 'Energex network handback form (ENX-HB-2026)',     required: true,  status: 'NOT_STARTED', dueDate: '2026-07-29', notes: null },
      { id: 'hd23', name: 'Handover certificate (generated from system)',    required: true,  status: 'NOT_STARTED', dueDate: '2026-07-31', notes: null },
    ]
  },
]
